// extracted by mini-css-extract-plugin
module.exports = {"product_title":"Product_product_title__29nFX","title":"Product_title__1hEKT","tips":"Product_tips__rdPkn"};